/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */
import CardFieldNoValidate from './CardFieldNoValidate';
import { HOC } from 'formsy-react';

export default HOC(CardFieldNoValidate);



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardField.js